"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var main_html_1 = __importDefault(require("./main.html"));
require("@components/hide-entire-report/hide-entire-report.component");
require("@services/exports/generic-exports-service");
var CHECK_PAGE_READY_TIMEOUT = 200;
(function (module) {
    function MainController($q, initService, env, $timeout, $routeParams, rum, navigationService, genericExportsService) {
        var _this = this;
        this.$onInit = function () {
            // Error Handling
            _this.error = env.get('error');
            if (_this.error) {
                $timeout(function () {
                    rum.appComplete();
                });
                return;
            }
            _this.ready = false;
            _this.hideEntireReport = false;
            /**
             * If there is no 'container' environment variable, then the
             * user is at the passcode entry page for a public report.
             */
            if (env.get('container')) {
                initService.init();
                initService.shouldHideEntireReport().then(function (hideEntireReport) {
                    if (hideEntireReport) {
                        _this.hideEntireReport = true;
                        // Delay the export so the error message can be rendered
                        // before GE takes the snapshot.
                        $timeout(function () {
                            genericExportsService.setupExport(true); // skip checkReady for Export
                            rum.appComplete();
                        }, 1000);
                        return;
                    }
                    initService.initWidgets().then(function () {
                        genericExportsService.setupExport();
                        initService.getSourcesUsedInReport();
                        return initService.computeConditionalWidgets();
                    }).then(function () {
                        initService.complete();
                        var checkPageReadyForExport = function () {
                            if (genericExportsService.isPageReadyForExport()) {
                                _this.ready = true;
                            }
                            else {
                                $timeout(checkPageReadyForExport, CHECK_PAGE_READY_TIMEOUT);
                            }
                        };
                        checkPageReadyForExport();
                    });
                });
            }
            else {
                _this.ready = true;
            }
            _this.isPublicView = _this.isPublic || $routeParams.preview;
            _this.isExport = !!navigationService.isExport;
        };
    }
    MainController.$inject = [
        '$q',
        'prInitService',
        'rsEnvironment',
        '$timeout',
        '$routeParams',
        'rum',
        'pr.navigationService',
        'pr.genericExportsService'
    ];
    module.component('prMain', {
        controller: MainController,
        controllerAs: 'mnCtrl',
        templateUrl: main_html_1.default,
        bindings: {
            isPublic: '='
        }
    });
}(angular.module('qualtrics.pr')));
